<script>
import { mapActions, mapGetters } from 'vuex';
import { Field, Form } from 'vee-validate';
import * as Yup from 'yup';

import VSelect from '@/components/Common/VSelect';
import VInput from '@/components/Common/VInput';

export default {
  props: {
    action: {
      type: String,
      default: null,
    }
  },
  components: {
    VSelect,
    VInput,
    VeeForm: Form,
    VeeField: Field,
  },
  data() {
    return {
      brand: null,
      model: null,
      year: null,
      generation: null,
      name: null,
      phone: null,
    };
  },
  setup() {
    const schema = Yup.object().shape({
      name: Yup.string().required(),
      phone: Yup.string().required(),
      brand: Yup.mixed().nullable(false).required(),
      model: Yup.mixed().nullable(false).required(),
      year: Yup.mixed().nullable(false).required(),
      generation: Yup.mixed().nullable(false).required(),
    });

    return {
      schema,
    };
  },
  watch: {
    models() {
      if (this.models.length === 1) {
        this.model = this.models[0];
      }
    },
    years() {
      if (this.years.length === 1) {
        this.year = this.years[0];
      }
    },
    generations() {
      if (this.generations.length === 1) {
        this.generation = this.generations[0];
      }
    },

    brand() {
      if (this.brand) {
        this.loadModels({ brand: this.brand?.id });

        this.model = null;
        this.year = null;
        this.generation = null;
      }
    },
    model() {
      if (this.model) {
        this.loadYears({ brand: this.brand?.id, model: this.model?.id });

        this.year = null;
        this.generation = null;
      }
    },
    year() {
      if (this.year) {
        this.loadGenerations({
          brand: this.brand?.id,
          model: this.model?.id,
          year: this.year?.id,
        });

        this.generation = null;
      }
    },
  },
  computed: {
    ...mapGetters({
      brands: 'Vikup/brands',
      models: 'Vikup/models',
      years: 'Vikup/years',
      generations: 'Vikup/generations',
      fetching: 'Vikup/fetching',
    }),

    formData() {
      return {
        name: this.name,
        phone: this.phone,
        brand: this.brand.text,
        model: this.model.text,
        creationYear: this.year.text,
        generation: this.generation.text,
        action: this.action,
      };
    },
  },
  created() {
    this.loadBrands();
  },
  methods: {
    ...mapActions({
      togglePopup: 'Popups/togglePopup',
      loadBrands: 'Vikup/loadBrands',
      loadModels: 'Vikup/loadModels',
      loadYears: 'Vikup/loadYears',
      loadGenerations: 'Vikup/loadGenerations',
      sendFormExpress: 'Vikup/sendFormExpress',
    }),

    onSubmit(value, actions) {
      this.togglePopup('popup-message');

      this.sendFormExpress(this.formData);
      this.reset();
      setTimeout(() => {
        actions.resetForm();
      }, 1000);
    },

    reset() {
      this.brand = null;
      this.model = null;
      this.year = null;
      this.generation = null;
      this.name = null;
      this.phone = null;
    },
  },
};
</script>

<template>
  <div>
    <vee-form
      :validation-schema="schema"
      novalidate
      @submit="onSubmit"
    >
      <div class="grid grid-cols-1 grid-rows-1 md:grid-cols-2 md:grid-rows-2 gap-3.5">
        <vee-field
          v-slot="{ handleChange, errorMessage }"
          name="name"
        >
          <v-input
            v-model="name"
            placeholder="Введите ваше имя*"
            theme="gray"
            class="bg-trnasparent"
            name="name"
            :error="errorMessage"
            @update:modelValue="handleChange"
          />
        </vee-field>

        <vee-field
          v-slot="{ handleChange, errorMessage }"
          name="phone"
        >
          <v-input
            v-model="phone"
            format="phone"
            theme="gray"
            placeholder="+7 (___) ___-__-__"
            :error="errorMessage"
            @update:modelValue="handleChange"
          />
        </vee-field>

        <vee-field
          v-slot="{ handleChange, errorMessage }"
          name="brand"
        >
          <v-select
            v-model="brand"
            :options="brands"
            label="text"
            placeholder="Выберите марку*"
            :error="errorMessage"
            @update:modelValue="handleChange"
          />
        </vee-field>

        <vee-field
          v-slot="{ handleChange, errorMessage }"
          name="model"
        >
          <v-select
            v-model="model"
            :options="models"
            label="text"
            :disabled="brand === null"
            placeholder="Выберите модель*"
            :error="errorMessage"
            @update:modelValue="handleChange"
          />
        </vee-field>

        <vee-field
          v-slot="{ handleChange, errorMessage }"
          name="year"
        >
          <v-select
            v-model="year"
            :options="years"
            label="text"
            :disabled="model === null"
            placeholder="Укажите год*"
            :error="errorMessage"
            @update:modelValue="handleChange"
          />
        </vee-field>

        <vee-field
          v-slot="{ handleChange, errorMessage }"
          name="generation"
        >
          <v-select
            v-model="generation"
            :options="generations"
            label="text"
            :disabled="year === null"
            placeholder="Выберите поколение*"
            :error="errorMessage"
            @update:modelValue="handleChange"
          />
        </vee-field>
      </div>

      <button
        type="submit"
        class="w-full bg-green rounded-md mt-5 flex items-center justify-center text-white hover:bg-blue-light hover:text-gray-600 text-semibold text-sm lg:text-base h-12 cursor-pointer transition ease-in-out duration-200"
      >
        Отправить
      </button>
    </vee-form>
  </div>
</template>
